import { mainMenuDefaultItems, MainMenuItem } from './constants'

export const cleanDeprecateItems = (items: any[]): MainMenuItem[] => {
  if (!items?.length) {
    return [...mainMenuDefaultItems]
  }
  return items.map(item => ({
    ...item,
    action: item.action === 'OPEN_PAGE' ? 'OPEN_SPACE' : item.action,
    spaceSlug: item.spaceSlug || `default::${item.page}`,
  }))
}
